import "@/store"

export const state = () => ({
  list: [],
  divisionList: []
})

export const getters = {
  list: (state) => state.list || [],
  divisionList: (state) => state.divisionList || []
  //   sortedList: (_, getters) => getters.list.sort( (a, b) => a.position - b.position)
}
export const mutations = {
  setList(state, payload) {
    state.list = payload || []
  },
  setDivisionList(state, payload) {
    state.divisionList = payload || []
  },

  createItem(state, payload) {
    state.list = [...state.list, payload]
  },

  updateItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload.id)

    if (f !== -1) {
      state.list = [
        ...state.list.slice(0, f),
        payload,
        ...state.list.slice(f + 1)
      ]
    }
  },

  deleteItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload)

    if (f !== -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  },
  deleteDivision(state, payload) {
    const f = state.divisionList.findIndex((item) => item.id === payload)

    if (f !== -1) {
      state.divisionList = [
        ...state.divisionList.slice(0, f),
        ...state.divisionList.slice(f + 1)
      ]
    }
  }
}

export const actions = {
  fetch({ commit }) {
    return this.$api
      .get("/admin/structure/department/list/")
      .then((res) => {
        if (res && res.data) {
          commit("setList", res.data)
          return res.data || []
        }
      })
      .catch((err) => console.log(err))
  },
  fetchDeps() {
    return this.$api
      .get("/admin/structure/department/list/?region_isnull=true")
      .then((res) => {
        if (res && res.data) {
          return res.data || []
        }
      })
      .catch((err) => console.log(err))
  },
  fetchDivisionList({ commit }) {
    return this.$api
      .get("/admin/structure/division/list/")
      .then((res) => {
        if (res && res.data) {
          commit("setDivisionList", res.data)
          return res.data || []
        }
      })
      .catch((err) => console.log(err))
  },

  detail(_, payload) {
    return this.$api
      .get("/admin/structure/department/" + payload + "/update/")
      .then((res) => {
        if (res && res.data) {
          return res.data || {}
        }
      })
      .catch((err) => console.log(err))
  },
  detailDivision(_, payload) {
    return this.$api
      .get("/admin/structure/division/" + payload + "/update/")
      .then((res) => {
        if (res && res.data) {
          return res.data || {}
        }
      })
      .catch((err) => console.log(err))
  },

  createItemAction({ commit }, payload) {
    return this.$api
      .post("/department/create", payload.data)
      .then((res) => {
        commit("createItem", res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },

  updateItemAction({ commit }, payload) {
    return this.$api
      .put("/department/update/" + payload.id, payload.data)
      .then((res) => {
        commit("updateItem", res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },

  removeItemAction({ commit }, payload) {
    return this.$api
      .delete("/admin/structure/department/" + payload + "/delete/")
      .then((res) => {
        if (res && res.status >= 200) {
          commit("deleteItem", payload)
          return true
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  },
  removeItem({ commit }, payload) {
    return this.$api
      .delete("/admin/structure/division/" + payload + "/delete/")
      .then((res) => {
        if (res && res.status >= 200) {
          commit("deleteDivision", payload)
          return true
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
